import React, { Component }  from "react";
import {Collapse, NavbarBrand, NavbarToggler} from "reactstrap";
import { Link } from 'react-router-dom';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarContent,
  SidebarFooter
} from "react-pro-sidebar";
import { FaGem, FaList, FaCodiepie, FaSolarPanel } from "react-icons/fa";
import { RiUserSharedFill } from "react-icons/ri";
import { GoRepoPull } from "react-icons/go";
import { GrConfigure } from "react-icons/gr";
import './css/custom.css';
import './css/SideBar.css';
import { AppContext } from './../AppContext';

import logo from './img/svg/Logosistema.svg';
import { components } from "react-select";

const styles = {
    sideBarHeight: {
      height: "100vh",
    }, 
    sidebarBgColor: {
        bgcolor: "#ffffff",
    },   
}

const headerStyle = {
    padding: "0px",
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "1px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "noWrap"
};

export class SideBar extends Component {
    static displayName = SideBar.name;

    constructor(props) {
        super(props);
        
        this.state = {
            iduser: 0,
            roles: [],
            activePage: '/',
        };

        this.handleActive = this.handleActive.bind(this);
        this.activeRoute.bind(this);
    }

    componentDidMount() {
        let id = 0;
        let currentUser = this.context
        if (currentUser != null) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
        }
        /*console.log("id", id);*/
    }

    componentDidUpdate() {
        let currentUser = this.context
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
        }
    }

    handleActive(side) {
        if (!(side === this.state.activePage)) {
            this.setState({ activePage: side });
        }
    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }

  /*const currentUser = this.context;*/
    render() {        
        let iconStyles = { color: "white", fontSize: "1.5em" }
        return (
            <ProSidebar>
                <SidebarContent>
                    <Menu iconShape="circle">                        
                        {this.state.roles !== [] && (this.state.roles.includes('SUBDECANO') || this.state.roles.includes('COORDINADOR'))
                            ? <><MenuItem active={window.location.pathname === "/"} icon={<FaList />} style={{ fontSize: "1vw" }}>Carga{this.state.roles.includes('DECANO') ? <><br />Subdecano</> : <></>}<Link to="/" onClick={() => this.handleActive('/')} /></MenuItem>
                        <br /> </>: <></>}
                        {this.state.roles !== [] && this.state.roles.includes('SUBDECANO')
                            ? <><MenuItem active={window.location.pathname === "/Graficos"} icon={<FaCodiepie />} style={{ fontSize: "1vw" }}>Gráficos <Link to="/Graficos" onClick={() => this.handleActive('/Graficos')} /></MenuItem>
                              <br /> </>: <></>}                        
                        {this.state.roles !== [] && this.state.roles.includes('SUBDECANO')
                            ? <><MenuItem active={window.location.pathname === "/delegar"} icon={<RiUserSharedFill />} style={{ fontSize: "1vw" }}>Delegación <br />Masiva <Link to="/delegar" onClick={() => this.handleActive('/delegar')} /></MenuItem>
                              <br /> </>: <></>}
                        {this.state.roles !== [] && this.state.roles.includes('DECANO')
                            ? <><MenuItem active={window.location.pathname === "/Decano"} icon={<FaList />} style={{ fontSize: "1vw" }}>Carga<br />Decano<Link to="/Decano" onClick={() => this.handleActive('/Decano')} /></MenuItem>
                              <br /> </>: <></>}
                        {this.state.roles !== [] && this.state.roles.includes('VICERRECTOR')
                            ? <><MenuItem active={window.location.pathname === "/Vicerrector"} icon={<FaList />} style={{ fontSize: "1vw" }}>Carga<br />Vicerrector<Link to="/Vicerrector" onClick={() => this.handleActive('/Vicerrector')} /></MenuItem>
                              <br /></> : <></>}                        
                        {this.state.roles !== [] && this.state.roles.includes('ADMINISTRADOR')
                            ? <><MenuItem active={window.location.pathname === "/Administrador"} icon={<FaSolarPanel />} style={{ fontSize: "1vw" }}>Panel<br />Administrador<Link to="/Administrador" onClick={() => this.handleActive('/Administrador')} /></MenuItem>
                              <br /></>: <></>}                        
                        {this.state.roles !== [] && this.state.roles.includes('ADMINISTRADOR')
                            ? <><MenuItem active={window.location.pathname === "/Configuracion"} icon={<GrConfigure />} style={{ fontSize: "1vw" }}>Configuración<Link to="/Configuracion" onClick={() => this.handleActive('/Configuracion')} /></MenuItem>
                              <br /></>: <></>}
                        {this.state.roles !== [] && this.state.roles.includes('ADMINISTRADOR')
                            ?
                            <MenuItem active={window.location.pathname === "/Reportes"} icon={<GoRepoPull />} style={{ fontSize: "1vw" }}>Reportes<Link to="/Reportes" onClick={() => this.handleActive('/Reportes')} /></MenuItem>
                        : <></>}
                        <br />
                    </Menu>
                </SidebarContent>
            </ProSidebar>
        );
    }
}
SideBar.contextType = AppContext;
export default SideBar;